import { Grid, Space } from 'antd';
import { EmailOutlined, LocationOutlined, TimeOutlined, PhoneOutlined } from 'iglooicon';
import classnames from 'classnames';
import Typography from "../typography";
import Button from "../button";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LayoutFooter = function LayoutFooter(_ref) {
  var hiddenIglooIcon = _ref.hiddenIglooIcon,
    extraInfo = _ref.extraInfo,
    companyInfoRender = _ref.companyInfoRender,
    copyRightRender = _ref.copyRightRender,
    tel = _ref.tel,
    email = _ref.email,
    workTime = _ref.workTime,
    address = _ref.address,
    companyIcon = _ref.companyIcon;
  var useBreakpoint = Grid.useBreakpoint;
  var _useBreakpoint = useBreakpoint(),
    md = _useBreakpoint.md;
  var topRightContent = companyInfoRender ? companyInfoRender() : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "no-address-info",
      children: [tel && /*#__PURE__*/_jsxs("div", {
        className: "info-container",
        style: {
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsx(PhoneOutlined, {}), /*#__PURE__*/_jsx("div", {
          children: typeof tel === 'string' ? /*#__PURE__*/_jsx(Typography, {
            level: "body2",
            className: "info-span",
            children: tel
          }) : tel
        })]
      }), email && /*#__PURE__*/_jsxs("div", {
        className: "info-container",
        style: {
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsx(EmailOutlined, {}), /*#__PURE__*/_jsx("div", {
          children: typeof email === 'string' ? /*#__PURE__*/_jsx(Typography, {
            level: "body2",
            className: "info-span",
            children: email
          }) : email
        })]
      }), workTime && /*#__PURE__*/_jsxs("div", {
        className: "info-container",
        children: [/*#__PURE__*/_jsx(TimeOutlined, {}), /*#__PURE__*/_jsx("div", {
          children: typeof workTime === 'string' ? /*#__PURE__*/_jsx(Typography, {
            level: "body2",
            className: "info-span",
            children: workTime
          }) : workTime
        })]
      })]
    }), address && /*#__PURE__*/_jsxs(Space, {
      size: 16,
      align: "start",
      children: [/*#__PURE__*/_jsx(LocationOutlined, {
        style: {
          fontSize: 24
        }
      }), /*#__PURE__*/_jsx("div", {
        children: typeof address === 'string' ? /*#__PURE__*/_jsx(Typography, {
          level: "body2",
          className: "info-span",
          children: address
        }) : address
      })]
    })]
  });
  if (md) {
    return /*#__PURE__*/_jsx("div", {
      className: "igloo-layout-footer",
      children: /*#__PURE__*/_jsxs("div", {
        className: "footer-content",
        children: [extraInfo && extraInfo(), /*#__PURE__*/_jsxs(Space, {
          size: 32,
          align: "start",
          className: "footer-top",
          children: [!hiddenIglooIcon && /*#__PURE__*/_jsx("div", {
            className: "top-left",
            children: companyIcon ? /*#__PURE__*/_jsx("img", {
              src: companyIcon
            }) : /*#__PURE__*/_jsx("div", {
              className: "igloo-logo"
            })
          }), topRightContent]
        }), /*#__PURE__*/_jsx("div", {
          className: "footer-divider"
        }), /*#__PURE__*/_jsxs("div", {
          className: "footer-bottom",
          children: [copyRightRender ? copyRightRender("\xA9 ".concat(new Date().getFullYear(), " Powered by Igloo. All Rights Reserved.")) : /*#__PURE__*/_jsx(Typography, {
            level: "body3",
            children: "\xA9 ".concat(new Date().getFullYear(), " Powered by Igloo. All Rights Reserved.")
          }), /*#__PURE__*/_jsxs(Typography, {
            level: "body3",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "text",
              onClick: function onClick() {
                return window.open('https://contents.iglooinsure.com/privacypolicy');
              },
              children: /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                children: "Privacy Policy"
              })
            }), ' ', /*#__PURE__*/_jsx("span", {
              style: {
                margin: '0px 16px'
              },
              children: "|"
            }), /*#__PURE__*/_jsx(Button, {
              type: "text",
              onClick: function onClick() {
                return window.open('https://contents.iglooinsure.com/termsofservice');
              },
              children: /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                children: "Terms of Service"
              })
            })]
          })]
        })]
      })
    });
  } else {
    return /*#__PURE__*/_jsx("div", {
      className: "igloo-layout-footer",
      children: /*#__PURE__*/_jsxs("div", {
        className: "footer-content",
        children: [extraInfo && extraInfo(), !hiddenIglooIcon && (companyIcon ? /*#__PURE__*/_jsx("img", {
          src: companyIcon
        }) : /*#__PURE__*/_jsx("div", {
          className: "igloo-logo"
        })), /*#__PURE__*/_jsxs("div", {
          className: classnames('compony-info', {
            'compony-info-without-icon': hiddenIglooIcon
          }),
          children: [tel && /*#__PURE__*/_jsxs("div", {
            className: "info-item",
            children: [/*#__PURE__*/_jsx(PhoneOutlined, {}), /*#__PURE__*/_jsx("div", {
              children: typeof tel === 'string' ? /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                className: "info-span",
                children: tel
              }) : tel
            })]
          }), email && /*#__PURE__*/_jsxs("div", {
            className: "info-item",
            children: [/*#__PURE__*/_jsx(EmailOutlined, {}), /*#__PURE__*/_jsx("div", {
              children: typeof email === 'string' ? /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                className: "info-span",
                children: email
              }) : email
            })]
          }), workTime && /*#__PURE__*/_jsxs("div", {
            className: "info-item",
            children: [/*#__PURE__*/_jsx(TimeOutlined, {}), /*#__PURE__*/_jsx("div", {
              children: typeof workTime === 'string' ? /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                className: "info-span",
                children: workTime
              }) : workTime
            })]
          }), address && /*#__PURE__*/_jsxs("div", {
            className: "info-item",
            children: [/*#__PURE__*/_jsx(LocationOutlined, {
              style: {
                fontSize: 24
              }
            }), /*#__PURE__*/_jsx("div", {
              children: typeof address === 'string' ? /*#__PURE__*/_jsx(Typography, {
                level: "body3",
                className: "info-span",
                children: address
              }) : address
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "footer-bottom",
          children: [/*#__PURE__*/_jsx("div", {
            children: copyRightRender ? copyRightRender( /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("div", {
                children: ["\xA9 ", new Date().getFullYear(), " Powered by Igloo."]
              }), /*#__PURE__*/_jsx("div", {
                children: "All Rights Reserved."
              })]
            })) : /*#__PURE__*/_jsxs(Typography, {
              level: "body3",
              children: ["\xA9 ".concat(new Date().getFullYear(), " Powered by Igloo."), /*#__PURE__*/_jsx("div", {
                children: "All Rights Reserved."
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs(Typography, {
              level: "body3",
              children: [/*#__PURE__*/_jsx(Button, {
                type: "text",
                onClick: function onClick() {
                  return window.open('https://contents.iglooinsure.com/privacypolicy');
                },
                children: /*#__PURE__*/_jsx(Typography, {
                  level: "body3",
                  children: "Privacy Policy"
                })
              }), ' ', /*#__PURE__*/_jsx("span", {
                style: {
                  margin: '0px 16px'
                },
                children: "|"
              }), ' ', /*#__PURE__*/_jsx(Button, {
                type: "text",
                onClick: function onClick() {
                  return window.open('https://contents.iglooinsure.com/termsofservice');
                },
                children: /*#__PURE__*/_jsx(Typography, {
                  level: "body3",
                  children: "Terms of Service"
                })
              })]
            })
          })]
        })]
      })
    });
  }
};
LayoutFooter.displayName = 'LayoutFooter';
export default LayoutFooter;